import React from 'react'
import {Button, Header, Input, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import { createUserLog } from '../../lib/api';
import {useSelector} from "react-redux";

const OperationModePSM3 =({option, data, channel, tagid, isOperationModeCopied, setIsOperationModeCopied, parentcallback}) => {

    const [open,setOpen]= React.useState(false);
    const [opdata, setOPdata]= React.useState([]);
    const [extdata, setExtdata]= React.useState([]);
    const ppid = useSelector(state => state.header.ppid);
    const user = useSelector(state => state.nav.user);
    const electronApp = useSelector(state => state.nav.electronApp);

    React.useEffect(() => {

        if(data.length !== 0 && !isOperationModeCopied){
            if(!isOperationModeCopied){
                opdata.length = 0;
            }
            if(opdata.length === 0){
                opdata.push({'tag_id': 17425,'name': 'OPERIN_IDLE', 'tag_value': data[17425]});
                opdata.push({'tag_id': 17428,'name': 'OPERIN_LOADSHARE', 'tag_value': data[17428]});
                opdata.push({'tag_id': 17426, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': data[17426]});
                opdata.push({'tag_id': 17427, 'name': 'OPERIN_GRIDIND', 'tag_value': data[17427]});
                setOPdata(opdata);
                extdata.push({'tag_id': 39999, 'tag_value': data[39999]});
                setExtdata(extdata);
                setIsOperationModeCopied(true);
            }

        }

    }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleOpen = () => setOpen( true);
    const handleClose = () => setOpen( false);

    const handleEXTCheck = (event, {id}) => {
        switch(id){
            case 'EXTERNAL':
                setExtdata([{'tag_id':39999, 'tag_value': 1}]);
                break;
            case 'LOCAL':
                setExtdata([{'tag_id':39999, 'tag_value': 0}]);
                break;
            default:
                setExtdata([{'tag_id':39999, 'tag_value': 0}]);
                break;
        }
    }

    const handleEXTOK = (event) => {
        event.preventDefault();
        var writedata = [{'tag_id': tagid, 'tag_value': extdata}];
        socket.emit('write tag', extdata);
        parentcallback(true);
        setOpen(false);
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ tag_id: extdata, type: "EXT DISPATCH" }),
            };
            createUserLog({ log }).catch(console.error);
        }
    }

    const handleCheck = (event, {id}) => {
        switch(id){
            case 'IDLE':
                setOPdata([{'tag_id':17425, 'name': 'OPERIN_IDLE', 'tag_value': 1}, {'tag_id':17428, 'name': 'OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':17426, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':17427, 'name': 'OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'LOADSHARE':
                setOPdata([{'tag_id':17425, 'name': 'OPERIN_IDLE', 'tag_value': 0}, {'tag_id':17428, 'name': 'OPERIN_LOADSHARE', 'tag_value': 1}, {'tag_id':17426, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':17427, 'name': 'OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'GRIDCONN':
                setOPdata([{'tag_id':17425, 'name': 'OPERIN_IDLE', 'tag_value': 0}, {'tag_id':17428, 'name': 'OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':17426, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 1}, {'tag_id':17427, 'name': 'OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'GRIDIND':
                setOPdata([{'tag_id':17425, 'name': 'OPERIN_IDLE', 'tag_value': 0}, {'tag_id':17428, 'name': 'OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':17426, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':17427, 'name': 'OPERIN_GRIDIND', 'tag_value': 1}]);
                break;
            default:
                setOPdata([{'tag_id':17425, 'name': 'OPERIN_IDLE', 'tag_value': 1}, {'tag_id':17428, 'name': 'OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':17426, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':17427, 'name': 'OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
        }
    }
    const handleOPOK = (event, id) => {
        event.preventDefault();
        
        socket.emit('button click', {'buttonClickType': channel, 'tags': opdata});
        parentcallback(true);
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({
                    tag_id: opdata,
                    type: "Operation Mode Setup",
                }),
            };
            createUserLog({ log }).catch(console.error);
        }
        setOpen(false);
    }

    return (
        <div>
            {option === 1 ?
                <Modal trigger={<Button color='blue'>OPERATION MODE PSM3</Button>}
                       style={styles.toggle}
                       open={open}
                       onClose={handleClose}
                       onOpen={handleOpen}>
                    <Modal.Header>OPERATION MODE SETUP</Modal.Header>
                    <Modal.Description>
                        <Header style={styles.header}> OPERATION MODE</Header>
                    </Modal.Description>
                    <Modal.Content>
                        <Input
                            type='radio'
                            id='IDLE'
                            checked={(opdata.length > 0) ? opdata.find(el => el.name === 'OPERIN_IDLE').tag_value === 1 : false }
                            onChange={handleCheck}
                            label='IDLE'
                            style={styles.checkbox1}
                        />
                        <Input
                            type='radio'
                            id='LOADSHARE'
                            disabled
                            label='LOADSHARE'
                            checked={(opdata.length > 0) ? opdata.find(el => el.name === 'OPERIN_LOADSHARE').tag_value === 1 : false}
                            onChange={handleCheck}
                            style={styles.checkbox1}
                        />
                        <Input
                            type='radio'
                            id='GRIDCONN'
                            label='GRID CONNECT'
                            checked={(opdata.length > 0) ? opdata.find(el => el.name === 'OPERIN_GRIDCONNECT').tag_value === 1 : false}
                            onChange={handleCheck}
                            style={styles.checkbox1}
                        />
                        <Input
                            type='radio'
                            id='GRIDIND'
                            disabled
                            checked={(opdata.length > 0) ? opdata.find(el => el.name === 'OPERIN_GRIDIND').tag_value === 1 : false}
                            label='GRID INDEPENDENT'
                            onChange={handleCheck}
                            style={styles.checkbox1}
                        />

                    </Modal.Content>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id='1'
                                content='OK'
                                onClick={handleOPOK}
                        />
                        <Button color={'red'}
                                size='small'
                                id='2'
                                content='Cancel'
                                onClick={handleClose}
                        />
                    </Modal.Actions>
                </Modal>
                :
                <Modal trigger = {<Button color = 'blue'>EXT DISPATCH PSM3</Button>}
                       style = {styles.toggle}
                       open = {open}
                       onClose={handleClose}
                       onOpen={handleOpen}>
                    <Modal.Header>Select Location of Power Dispatch </Modal.Header>
                    <Modal.Description>
                        <Header style={styles.header}>Select Choice for ExternalPower </Header>
                    </Modal.Description>
                    {/*<Modal.Content>*/}
                    {/*    <Input*/}
                    {/*        type='radio'*/}
                    {/*        id='EXTERNAL'*/}
                    {/*        label='External Hardware Control'*/}
                    {/*        checked={(extdata.length > 0) ? extdata[0].tag_value === 1 : false}*/}
                    {/*        onChange={handleEXTCheck}*/}
                    {/*        style={styles.checkbox1}*/}
                    {/*    />*/}
                    {/*    <Input*/}
                    {/*        type='radio'*/}
                    {/*        id='LOCAL'*/}
                    {/*        label='Local-Operator Control'*/}
                    {/*        checked={(extdata.length > 0) ? extdata[0].tag_value === 0 : false}*/}
                    {/*        onChange={handleEXTCheck}*/}
                    {/*        style={styles.checkbox1}*/}
                    {/*    />*/}
                    {/*</Modal.Content>*/}
                    {/*<Modal.Actions style = {styles.toggle}>*/}
                    {/*    <Button color='blue' id = '1' content={'Ok'} onClick={handleEXTOK}/>*/}
                    {/*    <Button color='red' id = '2' content={'Cancel'} onClick={handleClose}/>*/}
                    {/*</Modal.Actions>*/}
                </Modal>
            }
        </div>
    );
}

const styles = {
    input: {
        padding: '5px',
        marginLeft: '5px'
    },
    toggle: {
        maxWidth: '300px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '5px'
    },
    checkbox1: {
        flexDirection: 'row-reverse',
        marginRight: '40px',
        marginBottom: '5px'
    },
    checkbox: {
        margin: '2px'
    }
}

export default OperationModePSM3;

